import { useEffect, useRef } from 'react';
import { LottieRefCurrentProps } from 'lottie-react';
import { logEvent } from '@/etc/firebase'; // Firebase 이벤트 로깅 함수

import GASection from './GASection';
import OverviewTopsection from './OverviewTopsection';
import { useParams } from 'react-router-dom';

export const ApageOverview = ({ active }: { active: boolean }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const hasLoggedRef = useRef(false); // 진입 로그 여부 저장
  const { group } = useParams(); // apage 또는 bpage

  useEffect(() => {
    if (active) {
      lottieRef.current?.goToAndPlay(0);

      // 처음 진입한 경우에만 로그
      if (!hasLoggedRef.current) {
        logEvent('enter_page_overview', {
          targetPage: group,
        });
        hasLoggedRef.current = true;
      }
    }
  }, [active]);

  return (
    <div className="flex h-full flex-col items-center rounded-[12px]  bg-white pt-[80px]">
      <div className="flex w-full flex-1">
        <OverviewTopsection lottieRef={lottieRef} />
      </div>
      <div className="flex pb-[32px]">
        <GASection />
      </div>
    </div>
  );
};

// BpageOverview도 같은 로직 적용
export const BpageOverview = ApageOverview;
